import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import Icon3 from "../../assest/images/Icon3.png";
import Icon5 from "../../assest/images/Icon5.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import { Modal, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";

function LGCM() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const isProcessingRef = useRef(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [originalEditData, setOriginalEditData] = useState(null);
  const [showUpdateAsterisk, setShowUpdateAsterisk] = useState(false);
  const [isToastActive, setIsToastActive] = useState(false);

  // Phone input country code support
  const allowedCountries = ["in", "af", "dz", "au", "at", "be", "us"];
  const [phoneNumberCountry, setPhoneNumberCountry] = useState("91");
  const [resetCounter, setResetCounter] = useState(0);
  const prevCountryRef = useRef(phoneNumberCountry || "91");

  const phoneNumberToCountryCode = (dialCode) => {
    dialCode = String(dialCode);
    switch (dialCode) {
      case "91":
        return "in";
      case "1":
        return "us";
      case "93":
        return "af";
      case "213":
        return "dz";
      case "61":
        return "au";
      case "43":
        return "at";
      case "32":
        return "be";
      default:
        return undefined;
    }
  };

  const phoneLengthMapping = {
    91: 10,
    93: 9,
    213: 9,
    61: 9,
    43: 10,
    32: 9,
    1: 10,
  };

  // Helper function to clean phone number (remove + and spaces)
  const cleanPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    return String(phoneNumber).replace(/[\s+\-()]/g, "");
  };

  // Helper function to format phone number for display
  const formatPhoneNumberDisplay = (phoneNumber) => {
    if (!phoneNumber) return "-";

    // Sort country codes by length (longest first) to match correctly
    const sortedCodes = Object.keys(phoneLengthMapping).sort(
      (a, b) => b.length - a.length,
    );

    // Check which country code this number has
    for (const code of sortedCodes) {
      if (phoneNumber.startsWith(code)) {
        const localNumber = phoneNumber.slice(code.length);
        return `+${code} ${localNumber}`;
      }
    }

    // If no country code found, return as-is
    return phoneNumber;
  };

  const [formdata, setFormdata] = useState({
    LGCM_Name: "",
    LGCVM_VehicleNumber: "",
    LGCVM_VehicleName: "", // ✅ NEW (mandatory)
    LGCVM_Dimension: "", // ✅ NEW (optional)
    LGCVM_DriverName: "", // ✅ NEW Driver Name
    LGCVM_DriverNumber: "", // ✅ NEW Driver Number
    LGCM_Status: 1,
    LGCM_CompanyID: UM_CompanyID,
    LGCM_CompanyGrpID: UM_CompanyGrpID,
    LGCM_CreatedBy: UM_UserId,
    LGCM_SCPID: selectedScpId,
  });
  const [touched, setTouched] = useState({
    LGCM_Name: false,
    LGCVM_VehicleName: false,
    LGCVM_VehicleNumber: false,
    LGCVM_DriverName: false,
    LGCVM_DriverNumber: false,
  });
  const [addAttempted, setAddAttempted] = useState(false);
  const [updateAttempted, setUpdateAttempted] = useState(false);

  const [message, setMessage] = useState("");
  const [validationError, setValidationError] = useState({
    LGCM_Name: "",
    LGCVM_VehicleNumber: "",
    LGCVM_VehicleName: "",
    LGCVM_Dimension: "", // ✅ add this
    LGCVM_DriverName: "",
    LGCVM_DriverNumber: "",
  });

  const [vehicleDetails, setVehicleDetails] = useState([]);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [vehicleNumbers, setVehicleNumbers] = useState([]);
  const [confirmAdd, setConfirmAdd] = useState(false);
  const [vehicleNumberEmpty, setVehicleNumberEmpty] = useState(false);
  const [addVehicleTriggered, setAddVehicleTriggered] = useState(false);
  const [addVehiclenumberTriggered, setaddVehiclenumberTriggered] =
    useState(false);
  const [isAddingVehicle, setIsAddingVehicle] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);

  const validateField = (name, rawValue) => {
    let error = "";
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;

    switch (name) {
      case "LGCM_Name":
        if (!value) {
        } else if (!/^[A-Za-z0-9]/.test(value)) {
          error = "First character must be alphanumeric";
        } else if (!/^[a-zA-Z0-9-_ ]+$/.test(value)) {
          error = "Please use only special characters like -,_ and space";
        } else if (
          value.length > 1 &&
          (!/^[a-zA-Z0-9]$/.test(value[0]) ||
            !/^[a-zA-Z0-9]$/.test(value[value.length - 1]))
        ) {
          error = "First and last character must be alphanumeric";
        } else if (/[-_ ]{2,}/.test(value)) {
          error = "Consecutive special characters are not allowed";
        } else if (value.length > 45) {
          error = "Maximum length is 45 characters";
        }
        break;
      case "LGCVM_VehicleNumber":
        if (!value) {
          // handled on ADD click
        } else if (!/^[A-Za-z0-9]/.test(value)) {
          error = "First and last character must be alphanumeric";
        } else if (!/\d/.test(value)) {
          error = "At least one digit is required";
        } else if (!/^[A-Za-z0-9\s-]+$/.test(value)) {
          error = "Please use only alphanumeric characters, - and space";
        } else if (!/^[A-Za-z0-9]$/.test(value[value.length - 1])) {
          error = "Last character must be alphanumeric";
        } else if (!/^([A-Za-z0-9]+[-\s]?[A-Za-z0-9]+)+$/.test(value)) {
          error = "Invalid format. Example: GJ-13-BD-3024";
        } else if (value.length > 45) {
          error = "Maximum length is 45 characters";
        }
        break;

      case "LGCVM_VehicleName":
        if (!value) {
          // optional / handled elsewhere
        } else if (
          !/^[a-zA-Z0-9]$/.test(value[0]) ||
          !/^[a-zA-Z0-9]$/.test(value[value.length - 1])
        ) {
          error = "First and last character must be alphanumeric";
        } else if (!/^[a-zA-Z0-9-_ ]+$/.test(value)) {
          error = "Please use only special characters like -,_ and space";
        } else if (/[-_ ]{2,}/.test(value)) {
          error = "Consecutive special characters are not allowed";
        } else if (value.length > 45) {
          error = "Maximum length is 45 characters";
        }
        break;

      case "LGCVM_Dimension":
        if (value) {
          if (!/^[0-9]+$/.test(value)) {
            error = "Only positive numbers allowed";
          } else if (value.length !== 6) {
            // error = 'Exactly 6 digits required';
          }
        }
        break;
      case "LGCVM_DriverName":
        if (value) {
          if (!/^[a-zA-Z ]+$/.test(value)) {
            error = "Only alphabets and spaces allowed";
          } else if (value.length > 45) {
            error = "Maximum length is 45 characters";
          } else if (/  +/.test(value)) {
            error = "Consecutive special characters are not allowed";
          }
        }
        break;
      case "LGCVM_DriverNumber":
        // Phone validation - check if complete number of digits entered
        if (value) {
          const digits = value.replace(/\D/g, "");

          // Find which country code this number has
          let countryCode = null;
          let expectedLength = 0;

          for (const [code, length] of Object.entries(phoneLengthMapping)) {
            if (digits.startsWith(code)) {
              countryCode = code;
              expectedLength = parseInt(code.length) + length;
              break;
            }
          }

          // If we found a country code, validate the local number
          if (countryCode) {
            const localNumber = digits.slice(countryCode.length);

            // Check if starts with 0
            if (localNumber.startsWith("0")) {
              error = "Phone number cannot start with 0";
            }
            // Check if incomplete
            else if (
              localNumber.length > 0 &&
              digits.length !== expectedLength
            ) {
              const requiredDigits = phoneLengthMapping[countryCode];
              error = `Phone Number must be exactly ${requiredDigits} digits`;
            }
          }
        }
        break;
      case "LGCM_Status":
        if (!value) {
          error = "*";
        }
        break;
      default:
        break;
    }
    return error;
  };

  const logAudit = async (
    module,
    message,
    oldValue = "",
    newValue = "",
    isError = false,
    transactionDetails = [],
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 7,
      AUTR_SCPID: selectedScpId || null,
      AUTR_CompanyGrpId: UM_CompanyGrpID || null,
      AUTR_CompanyID: UM_CompanyID || null,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0, // Flag to determine if transaction details should be inserted
      transactionDetails, // Array of transaction details to be inserted into audittransaction
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Logistic Party Name:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        logAction("Failed to log action");
        throw new Error("Failed to log action");
      }
    } catch (error) {
      logAction("Error logging action:", error);
      console.error("Error logging action:", error);
    }
  };

  const handleInput = (e, countryData) => {
    // Handle PhoneInput onChange (value, countryData)
    if (typeof e === "string" && countryData) {
      const value = e;
      const newDialCode = countryData?.dialCode;
      const prevDialCode = prevCountryRef.current;
      const isCountryChange = newDialCode !== prevDialCode;
      const maxLength = phoneLengthMapping[newDialCode] || 10;

      let digits = value.replace(/\D/g, "");

      // Extract local number (remove dial code)
      let local = "";
      if (digits.startsWith(newDialCode)) {
        local = digits.slice(newDialCode.length);
      } else {
        local = digits;
      }

      // STRICT: Block input if trying to enter more than maxLength digits
      if (local.length > maxLength) {
        // Reject this input - don't update state
        return;
      }

      // Error only (do not block)
      if (local.startsWith("0") && local.length > 0) {
        setValidationError((prev) => ({
          ...prev,
          LGCVM_DriverNumber: "Phone number cannot start with 0",
        }));
      } else {
        setValidationError((prev) => ({ ...prev, LGCVM_DriverNumber: "" }));
      }

      // On country change → reset local number
      const finalValue = isCountryChange ? newDialCode : newDialCode + local;

      setFormdata((prev) => ({
        ...prev,
        LGCVM_DriverNumber: finalValue,
      }));

      setPhoneNumberCountry(newDialCode);
      prevCountryRef.current = newDialCode;

      setTouched((prev) => ({
        ...prev,
        LGCVM_DriverNumber: true,
      }));

      if (hasError) {
        setHasError(false);
      }

      return;
    }

    // Handle regular input onChange (e.target)
    const { name, value } = e.target;

    let finalValue = value;

    // Auto-remove leading spaces and prevent consecutive spaces
    if (["LGCM_Name", "LGCVM_VehicleName", "LGCVM_Dimension", "LGCVM_DriverName", "LGCVM_VehicleNumber"].includes(name)) {
      finalValue = value.trimStart().replace(/\s{2,}/g, " ");
    }

    if (name === "LGCVM_VehicleNumber") {
      finalValue = finalValue.toUpperCase();
    }

    // Restrict Vehicle Volume to exactly 6 digits
    if (name === "LGCVM_Dimension") {
      // Remove all non-digit characters
      const digits = finalValue.replace(/\D/g, "");
      // Block input if more than 6 digits
      if (digits.length > 6) {
        return;
      }
      finalValue = digits;
    }

    setFormdata((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));

    const error = validateField(name, finalValue);
    setValidationError((prev) => ({ ...prev, [name]: error }));

    // Clear error state when user starts typing
    if (hasError) {
      setHasError(false);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (value && typeof value === 'string') {
      const trimmedValue = value.trim();
      if (trimmedValue !== value) {
        setFormdata((prev) => ({
          ...prev,
          [name]: trimmedValue,
        }));
        const error = validateField(name, trimmedValue);
        setValidationError((prev) => ({ ...prev, [name]: error }));
      }
    }
  };

  const hasAnyValidationError = () => {
    return Object.values(validationError).some((err) => err);
  };

  // Format phone number with country code for saving: "+91 1234567890"
  const formatPhoneForSave = (phoneValue) => {
    if (!phoneValue) return null;

    // Remove all non-digits
    const digits = phoneValue.replace(/\D/g, "");

    // Extract country code (check all possible country codes)
    for (const [dialCode] of Object.entries(phoneLengthMapping)) {
      if (digits.startsWith(dialCode)) {
        const localNumber = digits.slice(dialCode.length);
        return `+${dialCode} ${localNumber}`;
      }
    }

    // Default to India if no match
    if (digits.startsWith("91")) {
      return `+91 ${digits.slice(2)}`;
    }

    // If no country code detected, assume +91
    return digits ? `+91 ${digits}` : null;
  };

  const handleAddVehicleNumber = () => {
    // Check if editing is in progress
    if (isEditing) {
      if (!toast.isActive("edit-in-progress")) {
        setIsToastActive(true);
        toast.error(
          "Please save or cancel the current edit before adding a new vehicle.",
          {
            toastId: "edit-in-progress",
            onOpen: () => setIsToastActive(true),
          },
        );
      }
      return;
    }

    // Immediate check using ref to prevent rapid clicks
    if (isProcessingRef.current) {
      return;
    }

    isProcessingRef.current = true;
    setIsAddingVehicle(true);
    setAddAttempted(true);
    setAddVehicleTriggered(true);
    setaddVehiclenumberTriggered(true);

    if (hasAnyValidationError()) {
      // console.log("Please fix validation errors before adding.");
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }

    // Check for empty required fields - just return without adding error messages
    if (
      !formdata.LGCVM_VehicleName ||
      !formdata.LGCM_Name ||
      !formdata.LGCVM_VehicleNumber
    ) {
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }

    const vehicleNumberError = validateField(
      "LGCVM_VehicleNumber",
      formdata.LGCVM_VehicleNumber,
    );
    if (vehicleNumberError) {
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }

    const nameError = validateField("LGCM_Name", formdata.LGCM_Name);
    if (nameError) {
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }

    // Validate driver number for incomplete numbers
    const driverNumberError = validateField(
      "LGCVM_DriverNumber",
      formdata.LGCVM_DriverNumber,
    );
    if (driverNumberError) {
      setValidationError((prev) => ({
        ...prev,
        LGCVM_DriverNumber: driverNumberError,
      }));
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }

    const isDuplicateInput = vehicleDetails.some(
      (vehicleDetail) =>
        vehicleDetail.vehicleNumber === formdata.LGCVM_VehicleNumber,
    );

    if (isDuplicateInput) {
      logAction(
        `Duplicate vehicle number "${formdata.LGCVM_VehicleNumber}" is not allowed`,
      );
      if (!toast.isActive("duplicate-vehicle")) {
        setIsToastActive(true);
        toast.error(
          `Vehicle Number : ${formdata.LGCVM_VehicleNumber} already exists.`,
          {
            toastId: "duplicate-vehicle",
            onOpen: () => setIsToastActive(true),
          },
        );
      }
      setHasError(true);
      isProcessingRef.current = false;
      setIsAddingVehicle(false);
      return;
    }
    setAddAttempted(false);

    // Format driver number with country code for database
    let formattedDriverNumber = formatPhoneForSave(formdata.LGCVM_DriverNumber);

    // Check if driver number contains only country code (no local digits)
    if (formattedDriverNumber) {
      const cleanedNumber = formattedDriverNumber.replace(/[\s+\-()]/g, "");
      // Check if it's only a country code (no additional digits after +XX)
      const isOnlyCountryCode = Object.keys(phoneLengthMapping).some(
        (code) => cleanedNumber === `+${code}` || cleanedNumber === code,
      );
      if (isOnlyCountryCode) {
        formattedDriverNumber = null;
      }
    }

    setVehicleDetails([
      ...vehicleDetails,
      {
        vehicleNumber: formdata.LGCVM_VehicleNumber,
        vehicleName: formdata.LGCVM_VehicleName,
        dimension: formdata.LGCVM_Dimension || null,
        driverName: formdata.LGCVM_DriverName || null,
        driverNumber: formattedDriverNumber,
        companyName: formdata.LGCM_Name,
      },
    ]);
    setVehicleNumbers([...vehicleNumbers, formdata.LGCVM_VehicleNumber]);
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Reset phone country to default
    setPhoneNumberCountry("91");
    setResetCounter((prev) => prev + 1);
    prevCountryRef.current = "91";

    if (vehicleDetails.length === 0) {
      setFormdata((prevFormData) => ({
        ...prevFormData,
        LGCM_Name_Disabled: true,
        LGCM_Status_Disabled: true,
      }));
    }

    setTouched({
      LGCM_Name: false,
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
      LGCVM_DriverName: false,
      LGCVM_DriverNumber: false,
    });
    setAddAttempted(false);
    setaddVehiclenumberTriggered(false);
    setAddVehicleTriggered(false);
    isProcessingRef.current = false;
    setIsAddingVehicle(false);
  };

  const handleShowModal = (index) => {
    setDeleteIndex(index);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setDeleteIndex(null);
  };

  const handleRemoveVehicleNumber = (index) => {
    const updatedVehicleDetails = [...vehicleDetails];
    updatedVehicleDetails.splice(index, 1);
    setVehicleDetails(updatedVehicleDetails);

    const updatedVehicleNumbers = [...vehicleNumbers];
    updatedVehicleNumbers.splice(index, 1);
    setVehicleNumbers(updatedVehicleNumbers);

    // Enable fields if there are remaining records
    if (updatedVehicleDetails.length === 0) {
      setFormdata((prevFormData) => ({
        ...prevFormData,
        LGCVM_VehicleNumber: "", // Reset LGCVM_VehicleNumber input value
        LGCM_Name_Disabled: false,
        LGCM_Status_Disabled: false,
      }));
    }
    setIsToastActive(true);
    toast.success(
      `Vehicle : ${vehicleDetails[deleteIndex]?.vehicleNumber} removed successfully.`,
      {
        onOpen: () => setIsToastActive(true),
        onClose: () => setIsToastActive(false),
      },
    );
    handleCloseModal(); // Close modal after action
  };

  const handleEdit = (index) => {
    const vehicle = vehicleDetails[index];
    setIsEditing(true);
    setEditingIndex(index);
    setOriginalEditData({ ...vehicle });

    // Clear validation errors from previous add attempt
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset add attempt flag
    setAddAttempted(false);

    // Reset touched state so asterisks can show on UPDATE click
    setTouched({
      LGCM_Name: false,
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
      LGCVM_DriverName: false,
      LGCVM_DriverNumber: false,
    });

    // Extract and format driver number with country code
    const rawDriverNumber = vehicle.driverNumber || "";
    const cleanedDriverNumber = cleanPhoneNumber(rawDriverNumber);
    let countryCode = "91";
    let formattedDriverNumber = "";

    if (cleanedDriverNumber) {
      // Sort country codes by length (longest first) to match correctly
      const sortedCodes = Object.keys(phoneLengthMapping).sort(
        (a, b) => b.length - a.length,
      );

      // Try to match known country codes at the start
      let foundCode = false;
      for (const code of sortedCodes) {
        if (cleanedDriverNumber.startsWith(code)) {
          countryCode = code;
          formattedDriverNumber = cleanedDriverNumber; // Use cleaned number
          foundCode = true;
          break;
        }
      }

      // If no country code found, prepend the default country code
      if (!foundCode) {
        formattedDriverNumber = countryCode + cleanedDriverNumber;
      }
    }

    setPhoneNumberCountry(countryCode);
    prevCountryRef.current = countryCode;
    setResetCounter((prev) => prev + 1);

    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: vehicle.vehicleNumber,
      LGCVM_VehicleName: vehicle.vehicleName,
      LGCVM_Dimension: vehicle.dimension || "",
      LGCVM_DriverName: vehicle.driverName || "",
      LGCVM_DriverNumber: formattedDriverNumber,
    }));
  };

  const handleSaveEdit = () => {
    // Set update attempted flag to show asterisks on empty fields
    setUpdateAttempted(true);

    // Clear the asterisk flag when user attempts to save edit
    setShowUpdateAsterisk(false);

    // Check for empty required fields - just return without adding error messages
    if (!formdata.LGCVM_VehicleNumber || !formdata.LGCVM_VehicleName) {
      setTouched((prev) => ({
        ...prev,
        LGCVM_VehicleNumber: false,
        LGCVM_VehicleName: false,
      }));
      return;
    }

    // Validate driver number explicitly to catch incomplete numbers
    const driverNumberError = validateField(
      "LGCVM_DriverNumber",
      formdata.LGCVM_DriverNumber,
    );
    if (driverNumberError) {
      setValidationError((prev) => ({
        ...prev,
        LGCVM_DriverNumber: driverNumberError,
      }));
    }

    // Validate all fields
    if (
      validationError.LGCVM_VehicleName ||
      validationError.LGCVM_VehicleNumber ||
      validationError.LGCVM_Dimension ||
      validationError.LGCVM_DriverName ||
      validationError.LGCVM_DriverNumber ||
      driverNumberError
    ) {
      return;
    }

    // Check for duplicate vehicle number (excluding current editing vehicle)
    const isDuplicate = vehicleDetails.some(
      (v, idx) =>
        idx !== editingIndex &&
        v.vehicleNumber === formdata.LGCVM_VehicleNumber,
    );

    if (isDuplicate) {
      if (!toast.isActive("edit-vehicle-duplicate")) {
        setIsToastActive(true);
        toast.error(
          `Vehicle Number: ${formdata.LGCVM_VehicleNumber} already exists.`,
          {
            toastId: "edit-vehicle-duplicate",
            onOpen: () => setIsToastActive(true),
          },
        );
      }
      return;
    }

    // Check if driver number contains only country code (no local digits)
    let finalDriverNumber = formdata.LGCVM_DriverNumber || null;
    if (finalDriverNumber) {
      const cleanedNumber = finalDriverNumber.replace(/\D/g, "");
      const isOnlyCountryCode = Object.keys(phoneLengthMapping).some(
        (code) => cleanedNumber === code,
      );
      if (isOnlyCountryCode) {
        finalDriverNumber = null;
      }
    }

    // Format driver number for save
    let formattedDriverNumber = finalDriverNumber;
    if (finalDriverNumber) {
      const digits = finalDriverNumber.replace(/\D/g, "");
      // Extract country code
      for (const [dialCode] of Object.entries(phoneLengthMapping)) {
        if (digits.startsWith(dialCode)) {
          const localNumber = digits.slice(dialCode.length);
          formattedDriverNumber = `+${dialCode} ${localNumber}`;
          break;
        }
      }
    }

    // Update vehicle details
    const updatedVehicleDetails = [...vehicleDetails];
    updatedVehicleDetails[editingIndex] = {
      ...updatedVehicleDetails[editingIndex],
      vehicleNumber: formdata.LGCVM_VehicleNumber,
      vehicleName: formdata.LGCVM_VehicleName,
      dimension: formdata.LGCVM_Dimension || null,
      driverName: formdata.LGCVM_DriverName || null,
      driverNumber: formattedDriverNumber,
    };

    setVehicleDetails(updatedVehicleDetails);

    // Reset edit state
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Clear form fields
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Clear validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset processing flag to allow SAVE button to work
    isProcessingRef.current = false;

    // Reset update attempted flag
    setUpdateAttempted(false);

    if (!toast.isActive("vehicle-updated")) {
      setIsToastActive(true);
      toast.success(`Vehicle : ${formdata.LGCVM_VehicleName} updated successfully.`, {
        toastId: "vehicle-updated",
        onOpen: () => setIsToastActive(true),
        onClose: () => setIsToastActive(false),
      });
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Clear form fields
    setFormdata((prev) => ({
      ...prev,
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    }));

    // Clear validation errors
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    // Reset phone number state
    setPhoneNumberCountry("91");
    prevCountryRef.current = "91";
    setResetCounter((prev) => prev + 1);

    // Reset processing flag
    isProcessingRef.current = false;

    // Reset update attempted flag
    setUpdateAttempted(false);
  };

  const handleCancel = () => {
    // Don't dismiss toasts here - it causes infinite loop with onClose callbacks
    setIsToastActive(false);

    setFormdata({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
      LGCM_Status: 1,
    });
    setTouched({
      LGCM_Name: false,
      LGCVM_VehicleName: false,
      LGCVM_VehicleNumber: false,
      LGCVM_DriverName: false,
      LGCVM_DriverNumber: false,
    });
    setAddAttempted(false);
    setMessage("");
    setVehicleDetails([]); // ✅ CLEAR TABLE
    setVehicleNumbers([]); // ✅ CLEAR NUMBERS
    setConfirmAdd(false);
    setFormSubmitted(false);
    setValidationError({
      LGCM_Name: "",
      LGCVM_VehicleNumber: "",
      LGCVM_VehicleName: "",
      LGCVM_Dimension: "",
      LGCVM_DriverName: "",
      LGCVM_DriverNumber: "",
    });

    setAddVehicleTriggered(false);
    setaddVehiclenumberTriggered(false);

    // Reset editing state
    setIsEditing(false);
    setEditingIndex(null);
    setOriginalEditData(null);

    // Reset phone number country code
    setPhoneNumberCountry("91");
    setResetCounter((prev) => prev + 1);
    prevCountryRef.current = "91";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isProcessingRef.current) {
      return;
    }

    // Check if user is in edit mode and show asterisk on UPDATE button
    if (isEditing) {
      setShowUpdateAsterisk(true);
      isProcessingRef.current = false;
      return;
    }

    isProcessingRef.current = true;
    setFormSubmitted(true);
    logAction("Logistic Party Master handlesubmit started :");
    setLoading(true);

    // Check if user has filled vehicle data but hasn't clicked ADD
    const hasVehicleData =
      formdata.LGCVM_VehicleName ||
      formdata.LGCVM_VehicleNumber ||
      formdata.LGCVM_Dimension;

    // Check if table length is greater than 0
    if (vehicleDetails.length === 0) {
      // Only show this message if user has filled vehicle data but hasn't added it
      if (hasVehicleData) {
        if (!toast.isActive("vehicle-required")) {
          setIsToastActive(true);
          toast.error(
            " At least one vehicle is required to save the logistic party.",
            {
              toastId: "vehicle-required",
              onOpen: () => setIsToastActive(true),
            },
          );
        }
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }
      // If no vehicle data is filled, just show validation with asterisks
      if (!formdata.LGCM_Name) {
        logAction("Please provide all required data");
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }
      // If LGCM_Name is filled but no vehicles, show the error
      if (!toast.isActive("vehicle-required")) {
        setIsToastActive(true);
        toast.error(
          "At least one vehicle is required to save the logistic party.",
          {
            toastId: "vehicle-required",
            onOpen: () => setIsToastActive(true),
          },
        );
      }
      setLoading(false);
      isProcessingRef.current = false;
      return;
    }

    // Validation check
    if (!formdata.LGCM_Name || !formdata.LGCM_Status) {
      logAction("Please provide all required data");
      setLoading(false);
      isProcessingRef.current = false;
      return;
    }

    // Validate required Context IDs
    if (!UM_UserId || !UM_CompanyID || !UM_CompanyGrpID || !selectedScpId) {
      const missingFields = [];
      if (!UM_UserId) missingFields.push("User ID");
      if (!UM_CompanyID) missingFields.push("Company ID");
      if (!UM_CompanyGrpID) missingFields.push("Company Group ID");
      if (!selectedScpId) missingFields.push("SCP ID");

      const errorMsg = `Missing required session data: ${missingFields.join(", ")}. Please try refreshing the page or logging in again.`;

      console.error(errorMsg);
      if (!toast.isActive("session-error")) {
        setIsToastActive(true);
        toast.error(errorMsg, {
          toastId: "session-error",
          onOpen: () => setIsToastActive(true),
          onClose: () => setIsToastActive(false),
        });
      }
      setLoading(false);
      isProcessingRef.current = false;
      return;
    }

    try {
      // Check for duplicate record
      const response = await fetch(
        `${config.API_URL}/logistic_company_master/checkDuplicate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            LGCM_Name: formdata.LGCM_Name,
            LGCM_SCPID: parseInt(selectedScpId),
          }),
        },
      );

      const data = await response.json();

      // Check for duplicate (status 409 or error field with duplicate message)
      if (response.status === 409 || data.error === "Duplicate data found") {
        setMessage("Duplicate value found");
        if (!toast.isActive("duplicate-party")) {
          setIsToastActive(true);
          toast.error(
            `Logistic Party : ${formdata.LGCM_Name} already exists.`,
            {
              toastId: "duplicate-party",
              onOpen: () => setIsToastActive(true),
              onClose: () => setIsToastActive(false),
            },
          );
        }
        logAction(
          `Logistic Party : ${formdata.LGCM_Name} already exists.`,
        );
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }

      if (!response.ok) {
        if (!toast.isActive("check-duplicate-error")) {
          setIsToastActive(true);
          toast.error(data.error || "Failed to check duplicate", {
            toastId: "check-duplicate-error",
            onOpen: () => setIsToastActive(true),
          });
        }
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }

      if (data.error) {
        setMessage(data.error);
        if (!toast.isActive("data-error")) {
          setIsToastActive(true);
          toast.error(data.error, {
            toastId: "data-error",
            onOpen: () => setIsToastActive(true),
          });
        }
        setLoading(false);
        isProcessingRef.current = false;
        return;
      }

      // Construct the request data object
      const requestData = {
        LGCM_Name: formdata.LGCM_Name,
        LGCM_Status: formdata.LGCM_Status,
        LGCM_SCPID: parseInt(selectedScpId),
        LGCM_CompanyID: parseInt(UM_CompanyID),
        LGCM_CompanyGrpID: parseInt(UM_CompanyGrpID),
        LGCM_CreatedBy: parseInt(UM_UserId),
        LGCVM_Vehicles: vehicleDetails.map((v) => ({
          vehicleNumber: v.vehicleNumber,
          vehicleName: v.vehicleName,
          dimension: v.dimension,
          driverName: v.driverName,
          driverNumber: v.driverNumber,
        })),
      };

      const transactionDetails = [
        {
          AUTRN_OldValue: "-",
          AUTRN_NewValue: formdata.LGCM_Name,
          AUTRN_ParamererName: "Logistic Party Name",
        },
        ...vehicleDetails.map(({ vehicleNumber }) => ({
          AUTRN_OldValue: "-",
          AUTRN_NewValue: vehicleNumber,
          AUTRN_ParamererName: "Vehicle Number",
        })),
        {
          AUTRN_OldValue: "-",
          AUTRN_NewValue: formdata.LGCM_Status,
          AUTRN_ParamererName: "Status",
        },
      ];

      const logisticCompanyResponse = await fetch(
        `${config.API_URL}/logistic_company_master/insertData`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        },
      );

      if (!logisticCompanyResponse.ok) {
        const errorData = await logisticCompanyResponse.json();
        console.error("Server error details:", errorData);
        throw new Error(
          errorData.message ||
          errorData.error ||
          "Error inserting logistic company data",
        );
      }

      // Handle success response...
      logAction(`Logistic Party Master handleSubmit function ended`);
      logAction(`${formdata.LGCM_Name} is saved successfully`);

      logAudit(
        "Logistic Party Name",
        `Logistic Party Name : ${formdata.LGCM_Name} saved successfully in database`,
        "-",
        `${formdata.LGCM_Name}`,
        false,
        transactionDetails,
      );

      // Reset form submission flags immediately to prevent asterisk flash
      setFormSubmitted(false);
      setAddAttempted(false);

      setIsToastActive(true);
      toast.success(
        `Logistic Party : ${formdata.LGCM_Name} saved successfully.`,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          onOpen: () => setIsToastActive(true),
          onClose: () => {
            setIsToastActive(false);
            handleCancel();
            setLoading(false);
            isProcessingRef.current = false;
          },
        },
      );
    } catch (error) {
      console.error("Error:", error);
      if (!toast.isActive("error-toast")) {
        setIsToastActive(true);
        toast.error("An error occurred while saving data. Please try again.", {
          toastId: "error-toast",
          onOpen: () => setIsToastActive(true),
        });
      }
      setMessage(
        "An error occurred while inserting data. Please try again later.",
      );
      logAction("An error occurred while inserting data.", true);
      setFormSubmitted(false);
      setLoading(false);
      isProcessingRef.current = false;
    }
  };

  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
        limit={1}
        newestOnTop={true}
      />
      {(loading || isToastActive) && (
        <div
          style={{
            position: "fixed", // Sit on top of the page content
            left: 0,
            top: 0,
            width: "100%", // Full width
            height: "100%", // Full height
            zIndex: 1000, // Sit on top of the other elements
          }}
        />
      )}

      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="main_container">
          <h2 className="formHeading" style={{ marginLeft: 0 }}>Logistic Party Master</h2>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Logistic Party Name
                  {(formSubmitted || addAttempted) &&
                    !formdata.LGCM_Name &&
                    !touched.LGCM_Name && (
                      <span className="text-danger"> *</span>
                    )}
                </label>

                <input
                  type="text"
                  name="LGCM_Name"
                  className={`form-input ${validationError.LGCM_Name ? "is-invalid" : ""}`}
                  placeholder=""
                  value={formdata.LGCM_Name}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  disabled={isToastActive}
                />
                {validationError.LGCM_Name && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px" }}
                  >
                    {validationError.LGCM_Name}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Vehicle Name
                  {(addAttempted || updateAttempted) &&
                    !formdata.LGCVM_VehicleName &&
                    !touched.LGCVM_VehicleName && (
                      <span className="text-danger"> *</span>
                    )}
                </label>

                <input
                  type="text"
                  name="LGCVM_VehicleName"
                  className={`form-input ${validationError.LGCVM_VehicleName ? "is-invalid" : ""}`}
                  value={formdata.LGCVM_VehicleName}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  autoComplete="off"
                  disabled={isToastActive}
                />
                {validationError.LGCVM_VehicleName && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px" }}
                  >
                    {validationError.LGCVM_VehicleName}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Vehicle Number
                  {(addAttempted || updateAttempted) &&
                    !formdata.LGCVM_VehicleNumber &&
                    !touched.LGCVM_VehicleNumber && (
                      <span className="text-danger"> *</span>
                    )}
                </label>

                <input
                  type="text"
                  name="LGCVM_VehicleNumber"
                  className={`form-input ${validationError.LGCVM_VehicleNumber ? "is-invalid" : ""}`}
                  placeholder=""
                  value={formdata.LGCVM_VehicleNumber}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  disabled={formdata.LGCVM_VehicleNumber_Disabled || isToastActive}
                />
                {validationError.LGCVM_VehicleNumber && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px" }}
                  >
                    {validationError.LGCVM_VehicleNumber}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Vehicle Volume</label>
                <input
                  type="text"
                  name="LGCVM_Dimension"
                  className={`form-input ${validationError.LGCVM_Dimension ? "is-invalid" : ""}`}
                  value={formdata.LGCVM_Dimension}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  disabled={isToastActive}
                />
                {validationError.LGCVM_Dimension && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px" }}
                  >
                    {validationError.LGCVM_Dimension}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Driver Name</label>
                <input
                  type="text"
                  name="LGCVM_DriverName"
                  className={`form-input ${validationError.LGCVM_DriverName ? "is-invalid" : ""}`}
                  value={formdata.LGCVM_DriverName}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  autoComplete="off"
                  disabled={isToastActive}
                />
                {validationError.LGCVM_DriverName && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px" }}
                  >
                    {validationError.LGCVM_DriverName}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Driver Phone Number</label>
                <PhoneInput
                  className="phone-input-custom"
                  key={phoneNumberCountry + "-" + resetCounter}
                  country={
                    phoneNumberToCountryCode(phoneNumberCountry) || "in"
                  }
                  value={formdata.LGCVM_DriverNumber}
                  onChange={(value, countryData) =>
                    handleInput(value, countryData)
                  }
                  inputClass="form-input"
                  dropdownClass="phone-dropdown-scroll phone-dropdown-up"
                  countryCodeEditable={false}
                  onlyCountries={allowedCountries}
                  enableSearch={false}
                  autoFormat={true}
                  autoComplete="off"
                />
                {validationError.LGCVM_DriverNumber && (
                  <div
                    className="invalid-feedback"
                    style={{ fontSize: "16px", display: "block" }}
                  >
                    {validationError.LGCVM_DriverNumber}
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6">
              {/* <div className="mb-3"> */}
              <label className="form-label">Status</label>
              <div className="select-container">
                <StatusCustomDropdown
                  name="LGCM_Status"
                  options={[
                    { value: 1, label: "Active" },
                    { value: 2, label: "Inactive" },
                  ]}
                  value={formdata.LGCM_Status || 1} // Assuming '1' is the value for Active
                  onChange={handleInput}
                  idKey="value"
                  displayKey="label"
                  fontSize="16px"
                  disabled={isToastActive}
                />
              </div>
              {/* </div> */}
            </div>

            <div className="col-md-6">
              <div
                className="mb-3"
                style={{ display: "flex", gap: "10px" }}
              >
                {isEditing ? (
                  <>
                    <button
                      type="button"
                      className="lgcm_add_btn"
                      onClick={handleSaveEdit}
                      disabled={isToastActive}
                    >
                      UPDATE
                    </button>
                    {showUpdateAsterisk && (
                      <span
                        className="text-danger"
                        style={{
                          fontSize: "20px",
                          marginTop: "10px",
                          marginRight: "10px",
                        }}
                      >
                        *
                      </span>
                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    className="lgcm_add_btn"
                    onClick={handleAddVehicleNumber}
                    disabled={isAddingVehicle || hasError || isToastActive}
                  >
                    ADD
                  </button>
                )}
              </div>
            </div>

            {vehicleDetails.length > 0 && (
              <div className="col-md-12 mt-4">
                <table className="tableClass">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Vehicle Name</th>
                      <th>Vehicle Number</th>
                      <th>Vehicle Volume</th>
                      <th>Driver Name</th>
                      <th>Driver Phone Number</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleDetails.map((v, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{v.vehicleName}</td>
                        <td>{v.vehicleNumber}</td>
                        <td>{v.dimension || "-"}</td>
                        <td>{v.driverName || "-"}</td>
                        <td>{formatPhoneNumberDisplay(v.driverNumber)}</td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "6px",
                            }}
                          >
                            <img
                              src={Icon3}
                              title="Edit"
                              alt="edit"
                              className="action_icon"
                              onClick={() => !isToastActive && handleEdit(index)}
                              style={{ width: "12px", height: "12px", cursor: "pointer", opacity: isToastActive ? 0.5 : 1 }}
                            />
                            <img
                              src={Icon5}
                              title="Remove"
                              alt="trash"
                              className="delete_btn"
                              style={{ height: "15px", width: "15px", cursor: "pointer", opacity: isToastActive ? 0.5 : 1 }}
                              onClick={() => !isToastActive && handleShowModal(index)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        <div className="button-container">
          <button
            type="submit"
            className="save_btn"
            disabled={showModal || loading || isToastActive}
          >
            SAVE
          </button>
          <button type="reset" onClick={handleCancel} className="reset_btn" disabled={isToastActive}>
            RESET
          </button>
          <Link to={isToastActive ? "#" : `/lgcmlist`} className="list_btn" type="button" style={{ pointerEvents: isToastActive ? "none" : "auto" }}>
            LIST
          </Link>
        </div>
      </form>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        backdrop="static"
        centered
      >
        {/* <Modal.Header closeButton> */}
        <Modal.Title
          style={{
            color: "#465a64",
            marginTop: "20px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          :: User Confirmation ::
        </Modal.Title>
        {/* </Modal.Header> */}
        <Modal.Body>
          <div className="confirmMsg" style={{ fontWeight: "bold" }}>
            {`Are you sure you want to remove this Vehicle : ${vehicleDetails[deleteIndex]?.vehicleNumber}`}{" "}
            ?
          </div>
        </Modal.Body>
        {/* <Modal.Footer> */}
        <div className="popup_btn_container">
          <button
            className="yes_btn"
            onClick={() => handleRemoveVehicleNumber(deleteIndex)}
          >
            YES
          </button>
          <button className="no_btn" onClick={handleCloseModal}>
            NO
          </button>
        </div>
        {/* </Modal.Footer> */}
      </Modal>
    </React.Fragment >
  );
}

export default LGCM;

